module.exports = __webpack_public_path__ + "media/images/icons/social/instagram-894c2d5ed1b2c73bb25b6aae85d4c44d.png";